






import { Component, Vue, Prop } from "vue-property-decorator";
import QuickAssistant from "../components/quick-assistant.vue";
import { IAssessment } from "../store/main.interfaces";
import { makeSimpleDigitalAssessmentObject } from "../store/assessment.util";

let entries: IAssessment[] = [];

@Component({
  components: { QuickAssistant }
})
export default class QuickQuestionsView extends Vue {}
